import styled, { css } from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

export const DateContainer = styled.div`
  width: 60px;
  text-align: right;
`;

export const Text = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  color: ${ColorPalette.HEX.OuterSpace};
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`;

const subtitleStyle = css`
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: ${ColorPalette.HEX.OuterSpace};
`;

export const Hour = styled.span`
  margin: 8px 0 25px 0;
  ${subtitleStyle}
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  margin-bottom: 25px;
  ${subtitleStyle}

  & > span {
    ${subtitleStyle}
  }

  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 0;
  }
`;

export const LineContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 9px;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 0 16px;
  }
`;

export const Line = styled.div`
  width: 2px;
  flex: 1;
  border: solid 1px ${ColorPalette.HEX.BrightGray};
`;

export const Divider = styled.div`
  height: 1px;
  border-bottom: solid 1px ${ColorPalette.HEX.BrightGray};
  grid-column: span 2;
  margin: 24px 0;
`;
